export var PLUGIN_NAME = "performance";
export var BIZ_LCP_ELEMENT_ID = "cone-arms-biz-lcp-element";

 //# sourceMappingURL=constant.js.map